var React = require('react');

function ArrowCircleUp48x48 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=48, Inverted=off, State=Default","stroke":"currentColor","strokeWidth":"2"},[React.createElement("g",{"id":"Icon/Arrow-reg","key":0},[React.createElement("path",{"id":"Vector","d":"M29 24l-4.5-5h-1L19 24","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M24 30V19","strokeLinejoin":"bevel","key":1})]),React.createElement("rect",{"x":"1","y":"1","width":"46","height":"46","rx":"23","key":1})]));
}

ArrowCircleUp48x48.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ArrowCircleUp48x48;

ArrowCircleUp48x48.default = ArrowCircleUp48x48;
